import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow_drop_down",
  "use": "arrow_drop_down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow_drop_down\">\n<title>arrow_drop_down</title>\n<path d=\"M6.984 9.984h10.031l-5.016 5.016z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol